import React, { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { styles } from '../styles/themes/style'

interface IContainerStyles {
    backgroundColorName?: any
}

interface IInformationBoxProps extends IContainerStyles { 
    message: ReactNode
}

const InformationBox: FunctionComponent<IInformationBoxProps> = ({ message, backgroundColorName }) => {
    return <Container backgroundColorName={backgroundColorName}>{message}</Container>
}

const Container = styled.div<IContainerStyles>`
    color: ${props => props.theme.primaryColor};
    font-family: NunitoSans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    padding: 16px 20px; 
    background: ${({backgroundColorName}) => backgroundColorName === 'red200' ? styles.colors.red200 : styles.colors.yellow300} 
`

export default InformationBox
